import { DashboardChip } from './DashboardChip';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import React from 'react';

interface ResolvedIssueChipProps {
    label?: React.ReactNode;
    onClick?: () => void;
    isDeactivated?: boolean;
}

export const ResolvedIssueChip = ({ label, onClick, isDeactivated }: ResolvedIssueChipProps) => {
    return (
        <DashboardChip
            text={label ?? <DoneOutlinedIcon fontSize='small' />}
            icon={label ? <DoneOutlinedIcon /> : <></>}
            backgroundColor="#4DB749"
            borderColor="#178315"
            onClick={onClick}
            isDeactivated={isDeactivated}
        />
    );
};